import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: 'reports',
    tagSub: "reports",
    exact: false,
    path: PATHS.REPORT.path,
    show: true,
    icon: "container",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.REPORT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "saleReports",
            group: "saleReports",
            tagSub: "reports",
            path: PATHS.REPORT.SALE_REPORT.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.SALE_REPORT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                `${DEFINE.GENERAL.ROUTE_NAME.ORDER}.${DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER}`,
                `${DEFINE.GENERAL.ROUTE_NAME.ORDER}.${DEFINE.GENERAL.PERMISSION.EXPORT_EXCLUDE_USER_INFO}`
            ],
        },
        {
            title: "saleReportsByOrder",
            group: "saleReportsByOrder",
            tagSub: "reports",
            path: PATHS.REPORT.SALE_REPORT_BY_ORDER.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.SALE_REPORT_BY_ORDER,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                `${DEFINE.GENERAL.ROUTE_NAME.ORDER}.${DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER}`,
                `${DEFINE.GENERAL.ROUTE_NAME.ORDER}.${DEFINE.GENERAL.PERMISSION.EXPORT_EXCLUDE_USER_INFO}`
            ],
        },
        {
            title: "saleReportsBySKU",
            group: "saleReportsBySKU",
            tagSub: "reports",
            path: PATHS.REPORT.SALE_REPORT_BY_SKU.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.SALE_REPORT_BY_SKU,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER, 
                `${DEFINE.GENERAL.PERMISSION.EXPORT_EXCLUDE_USER_INFO}`
            ],
        },
        {
            title: "redemptionReports",
            group: "redemptionReports",
            tagSub: "reports",
            path: PATHS.REPORT.VOUCHER_REDEEMTION_REPORT.path,
            exact: false,
            icon: 'faTag',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.VOUCHER_REDEEMTION_REPORT,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER],
        },
        {
            title: "cashflow",
            group: "cashflow",
            tagSub: "reports",
            path: PATHS.REPORT.CASH_FLOW_REPORT.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.CASH_FLOW_REPORT,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER, DEFINE.GENERAL.PERMISSION.RECEIPTS_PAYSLIP_CREATE],
            children: [
                {
                    title: "receiptsPayslipCreate",
                    group: "cashflow",
                    tagSub: "reports",
                    path: PATHS.REPORT.CASH_FLOW_REPORT.CREATE.path,
                    exact: false,
                    icon: 'dollar',
                    show: false,
                },
                {
                    title: "cashflowFiltered",
                    group: "cashflow",
                    tagSub: "reports",
                    path: PATHS.REPORT.CASH_FLOW_REPORT.pathFiltered,
                    exact: false,
                    icon: 'dollar',
                    show: false,
                }
            ]
        },
        {
            title: "orderDetailReportsBySku",
            group: "orderDetailReportsBySku",
            tagSub: "reports",
            path: PATHS.REPORT.ORDER_DETAIL_REPORT_BY_SKU.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.ORDER_DETAIL_REPORT_BY_SKU,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER,
            ],
        },
        {
            title: "collaborator",
            group: "collaborator",
            tagSub: "reports",
            path: PATHS.REPORT.COLLABORATOR_REPORT.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.COLLABORATOR_REPORT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.TOPUP,
                DEFINE.GENERAL.PERMISSION.EXPORT,
                DEFINE.GENERAL.PERMISSION.CHECK,
            ],
        },
        {
            title: "orderDetailReportsByHotel",
            group: "orderDetailReportsByHotel",
            tagSub: "reports",
            path: PATHS.REPORT.ORDER_DETAIL_REPORT_BY_HOTEL.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.ORDER_DETAIL_REPORT_BY_HOTEL,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER,
            ],
        },
        {
            title: "reportBundle",
            group: "reportBundle",
            tagSub: "reports",
            path: PATHS.REPORT.BUNDLE_REPORT.path,
            exact: false,
            icon: "faMoneyCheckAlt",
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.BUNDLE_REPORT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER,
            ]
        },
        {
            title: "btbOrder",
            group: "btbOrder",
            tagSub: "reports",
            path: PATHS.REPORT.BTB_ORDER_REPORT.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.BTB_ORDER_REPORT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT,
            ],
        },
        {
            title: "btbUseRoom",
            group: "btbUseRoom",
            tagSub: "reports",
            path: PATHS.REPORT.BTB_USE_ROOM_REPORT.path,
            exact: false,
            icon: 'faMoneyCheckAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.BTB_USE_ROOM_REPORT,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW,
                DEFINE.GENERAL.PERMISSION.EXPORT,
            ],
        },
    ],
}]